import Vue from 'vue'
const ImageUploader = async () => await import('vue-image-upload-resize')
Vue.use(ImageUploader)
